import React from "react";
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import styled from "styled-components";

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as LeftArrowSvg } from '../../../image/LeftArrow.svg';
import { ReactComponent as NoteSvg } from '../../../image/Note.svg';

export default function NoteNavigationBar() {
  const history = useHistory();
  let location = useLocation(); // URL 감지용
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  // 버튼 클릭시 //
  function onClickNavButton(division) {
    if (division === '1:1') history.push('/note/one-on-one');
    else if (division === 'Group') history.push('/note/program');
    else history.push('/home');
  }
  
  return (
    <TopLevelWrapper>
      <GoBackButton>
        <GoBackInnerButton onClick={() => onClickNavButton('/main')}>
          <StyledGoBack />
        </GoBackInnerButton>
      </GoBackButton>
      <NavigatorWrapper>
        <StyledNote />
        <NavigatorButtonWrapper>
          <NavigatorButton isClicked={location.pathname.includes('/note/one-on-one')} onClick={() => onClickNavButton('1:1')}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={18} color={location.pathname.includes('/note/one-on-one') ? theme.background : theme.text}>1:1</Text>
          </NavigatorButton>
          <NavigatorButton isClicked={location.pathname.includes('/note/program')} onClick={() => onClickNavButton('Group')}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={18} color={location.pathname.includes('/note/program') ? theme.background : theme.text}>{t('note.nav.group')}</Text>
          </NavigatorButton>
        </NavigatorButtonWrapper>
      </NavigatorWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  padding: 0px 20px 0px 100px;

  width: fit-content;
  height: 41px;

  gap: 10px;

  // background-color: #FFFFFF;
`;

const GoBackButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 40px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const GoBackInnerButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 28px;
  height: 28px;

  border: 2px solid ${props => props.theme.buttonFill};
  border-radius: 28px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;
`;

const StyledGoBack = styled(LeftArrowSvg)`
  margin-left: -2px;

  width: 9px;
  height: 15px;

  & path {
    fill: ${props => props.theme.white};
  }

  transition: all 0.3s ease-in-out;
`;

const NavigatorWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding-left: 15px;
  
  gap: 21px;

  border-radius: 28px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const NavigatorButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const NavigatorButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 93px;
  height: 40px;

  border-radius: 30px;
  // background-color: #FF8B48;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledNote = styled(NoteSvg)`
  width: 28px;
  height: 28px;

  & path {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;